import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

export interface LoaderState {
  isLoading: boolean;
  messageLoading: string;
}
export const state: LoaderState = {
  isLoading: false,
  messageLoading: 'loading',
};
export const getters: GetterTree<LoaderState, any> = {
  isLoading: () => state.isLoading,
  loadingMessage: () => state.messageLoading,
};
export const mutations: MutationTree<LoaderState> = {
  // Mutations
  setLoader(state: LoaderState, isLoading: boolean) {
    state.isLoading = isLoading;
    state.messageLoading = 'loading';
  },
  setMsgLoader(state: LoaderState, loaderState: LoaderState) {
    state.isLoading = loaderState.isLoading;
    state.messageLoading = loaderState.messageLoading;
  },
};
export const actions: ActionTree<LoaderState, any> = {};
export const loader: Module<LoaderState, any> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
